import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import InventoryService from '../../../../../services/InventoryService';
import { translate, formatData } from '../../../../../utils/util';

const ItemDroneDetail = (props) => {
    const [lotItem, setLotItem] = useState({});
    const [lotItemReadings, setLotItemReadings] = useState({});

    useEffect(() => {
        if (props.lotItem?.lotItemId) {
            props.getLotItem(props.lotItem?.lotItemId, props.user.vision);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.lotItem) {
            setLotItem(props.lotItem);
            if (props.lotItem.readings) {
                setLotItemReadings(props.lotItem.readings[0] || {});
            }
        }
    }, [props.lotItem]);

    return (
        <div className="container">
            <div className="card">
                <div className="card-content" style={{ padding: '10px' }}>
                    <div className="row" style={{ marginBottom: '0' }}>
                        <div className="row">
                            <div className="input-field no-padding col s5">
                                <span className="field f-1r truncate">{lotItem.location || ''}</span>
                                <label className="active" htmlFor="productId"> {translate('location', 'inventory')}</label>
                            </div>
                            <div className="input-field no-padding col s5">
                                <span className="field f-1r truncate">{lotItem.lotItemNumber || ''}</span>
                                <label className="active" htmlFor="productId"> {translate('inventoryNote', 'inventory')}</label>
                            </div>
                        </div>
                        <div className="input-field no-padding col s12">
                            <span className="field f-1r truncate">{lotItem.partNumberCode || ''}</span>
                            <label className="active" htmlFor="partNumber">{translate('partNumber', 'inventory')}</label>
                        </div>
                        <div className="input-field no-padding col s12">
                            <span className="field f-1r truncate">{lotItem.partNumberDescription || ''}</span>
                            <label className="active" htmlFor="partNumberDescription">{translate('partNumberDescription', 'inventory')}</label>
                        </div>
                        <div className="input-field no-padding col s12">
                            <span className="field f-1r truncate">{lotItemReadings.quantity || ''}</span>
                            <label className="active" htmlFor="quantity">{translate('quantity', 'inventory')}</label>
                        </div>
                        <div className="input-field no-padding col s12">
                            <span className="field f-1r truncate">{lotItemReadings.updateBy || ''}</span>
                            <label className="active" htmlFor="user">{translate('general.user')}</label>
                        </div>
                        <div className="input-field no-padding col s12">
                            <span className="field f-1r truncate">{formatData(lotItemReadings.updateOn)}</span>
                            <label className="active" htmlFor="data">{translate('inventory:general.date')}</label>
                        </div>
                        <div className="input-field no-padding col s6">
                            <span className="field f-1r truncate">{lotItem.divergent ? translate('general.yes') : translate('general.no')}</span>
                            <label className="active" htmlFor="divergent">{translate('inventory:general.divergent')}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.inventoryReducer.filter,
        lotItem: state.inventoryReducer.lotItem,
        user: state.userReducer.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLotItem: (lotItemId, vision) => {
            dispatch(InventoryService.getLotItem(lotItemId, vision));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ItemDroneDetail)));
